module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_harei-c489f1b89ec6b6cb3a863f03765c924f.png";